<div class="relative">
  <div class="relative flex flex-col justify-between bg-white h-screen shadow-light">
    <div class="flex flex-col z-10">
      <ng-content select="[sider-header]"></ng-content>
      <ng-content select="[sider-menu]"></ng-content>
    </div>

    <ng-content select="[sider-bottom]"></ng-content>
  </div>

  <div class="drop-shadow-[0_0_8px_rgba(0,0,0,0.2)] transform -translate-y-1/2 absolute top-1/2 right-0 translate-x-[14px] -z-60">
    <button class="bg-white text-sm h-16 w-4 [clip-path:polygon(0_0,100%_10%,100%_90%,0_100%)] hover:text-primary transition-all"
      (click)="toggle()">
      <ui-icon [class]="'text-gray-400 w-3'" [icon]="toogleIcon()"></ui-icon>
    </button>
  </div>
  <div class="bg-white transform -translate-y-1/2 absolute top-1/2 right-0 translate-x-[0px] -z-60">
    <div class="bg-white text-sm h-20 w-4 transition-all"></div>
  </div>
</div>
